import type {
  MarketDataCardConfig,
  MarketDataCardUnifiedLiquidityMarket,
  OrderIntent,
  OrdTypeEnum,
  PricingMode,
  Security,
  SideEnum,
} from '@talos/kyoko';

export const AVA_MARKET_DATA_CARD_MDS_THROTTLE = '250ms';

export interface MarketDataCardProps {
  config: MarketDataCardConfig;
  isDraggable: boolean;
  isDragged: boolean;
  defaultSubAccountId: number | undefined;
  onDelete: (config: MarketDataCardConfig) => void;
  onSave: (config: MarketDataCardConfig) => void;
  onHidePlaceholders: () => void;
  'data-testid'?: string;
}

export interface ClickToTradePreviewOrder {
  side: SideEnum;
  orderQty: string;
  orderCurrency: string;
  price: string;
  ordType: OrdTypeEnum;
  source: string;
  sourceIndex?: number;
  strategyName: string;
  intent: OrderIntent;
  pricingMode?: PricingMode;
  unifiedLiquidityMarketSymbols?: MarketDataCardUnifiedLiquidityMarket[];
}

export interface MarketDataCardHeaderProps {
  config: MarketDataCardConfig;
  security?: Security;
  isDraggable: boolean;
  activeOrder: ClickToTradePreviewOrder | undefined;
  defaultSubAccountId: number | undefined;
  onClickPrice: (args: OnClickPriceArgs) => void;
  onCancelActive: (args?: any) => void;
  onClickSettings: (arg?: any) => void;
  onSaveCard: (args: any) => void;
  onDelete: (config: MarketDataCardConfig) => void;
  onOpenMarketSelector?: () => void;
  marketSelectorTourDataTestId?: string;
  onOpenPublishCustomRate?: () => void;
  onOpenClearCustomRate?: () => void;
  canClearCustomRate?: boolean;
}

export interface OnClickPriceValues {
  side: SideEnum;
  orderQty: string;
  currency: string;
  price: string;
  expectedFillPrice?: string;
  expectedFillQty?: string;
  intent: OrderIntent;
  sourceIndex?: number;
}

export interface OnClickPriceArgs {
  values: OnClickPriceValues;
  source: string;
  unifiedLiquidityMarketSymbols?: MarketDataCardUnifiedLiquidityMarket[];
  overrideSide?: boolean;
  activateOrder?: boolean;
}
